import type { ChatProductDetail, ProductDetail, SellerOrderProductOption } from '../services/api.types';

type OrderChatProduct = ProductDetail | ChatProductDetail;

export const canCreateOrderFromChatProduct = (
  product: OrderChatProduct | null,
  currentUserId: string | null,
) => Boolean(
  product
  && currentUserId
  && product.user.id === currentUserId
  && product.productType !== 'DEMAND'
  // Orders are only for sale listings buyers can currently see.
  && product.status === 'ACTIVE'
  && !product.suspensionReason,
);

export const toSellerOrderProductOption = (
  product: OrderChatProduct,
): SellerOrderProductOption => ({
  id: product.id,
  title: product.title,
  unitPrice: product.price.price,
  currency: product.price.currency,
  unitType: product.price.unitType,
  status: product.status ?? 'ACTIVE',
  productLocationId: product.locationDto.id,
  productLocation: product.locationDto,
});
